export enum KEYBOARD {
  ESCAPE = 'Escape',
  KEYUP = 'keyup',
  KEYDOWN = 'keydown',
  INPUT = 'input'
}
